import React from "react";
import {PagesHero, Testimonials} from "../components";
import {testimonialsData} from "../constants/Testimonials";

const TestimonialsList = () => {
  return (
    <main>
      <PagesHero
        subTitle="Client Feedback"
        title="Testimonials"
        otherText1="Hear directly from those I've worked with."
        otherText2="Their experiences say more than I ever could."
        maskSubTitle="Proven Trust"
        maskTitle="Client Voices"
        maskOtherText1="Great work builds great relationships."
        maskOtherText2="Their words reflect the results we achieved."
      />

      <Testimonials
        testimonialsList={testimonialsData}
        isHeadingHide={false}
        isButtonHide={false}
      />
      <div className="section  many-more-text">
        <h3>Many More .... </h3>
      </div>
    </main>
  );
};

export default TestimonialsList;
